/**
 * Recently viewed products: cookie-based handles + fetch ?view=card (universal BB card).
 * Replaces jQuery tmpl + product JSON flow from legacy jquery.products.min.js for showRecentlyViewed only.
 * recordRecentlyViewed remains compatible with the same cookie name and behavior.
 */
(function ($) {
  'use strict';

  var COOKIE_NAME = 'shopify_recently_viewed';

  var cookieConfig = {
    expires: 90,
    path: '/',
    domain: window.location.hostname
  };

  function readHandles() {
    var raw = $.cookie(COOKIE_NAME);
    if (!raw) {
      return [];
    }
    return $.trim(raw).length ? raw.split(/\s+/) : [];
  }

  function writeHandles(handles) {
    $.cookie(COOKIE_NAME, handles.join(' '), cookieConfig);
  }

  function removeHandleFromCookie(handle) {
    var list = readHandles();
    var idx = $.inArray(handle, list);
    if (idx !== -1) {
      list.splice(idx, 1);
      writeHandles(list);
    }
  }

  function appendCardHtml($wrapper, html) {
    var $tmp = $('<div>').append($.parseHTML(html, document, true));
    var $item = $tmp.children('.halo-item').first();
    if (!$item.length) {
      $item = $tmp.find('.halo-item').first();
    }
    if ($item.length) {
      $wrapper.append($item);
    }
  }

  Shopify.Products = Shopify.Products || {};

  Shopify.Products.recordRecentlyViewed = function (options) {
    options = $.extend({ howManyToStoreInMemory: 10 }, options || {});
    var handles = readHandles();
    if (window.location.pathname.indexOf('/products/') === -1) {
      return;
    }
    var m = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/i);
    if (!m) {
      return;
    }
    var handle = m[1];
    var idx = $.inArray(handle, handles);
    if (idx === -1) {
      handles.unshift(handle);
      handles = handles.slice(0, options.howManyToStoreInMemory);
    } else {
      handles.splice(idx, 1);
      handles.unshift(handle);
    }
    writeHandles(handles);
  };

  Shopify.Products.showRecentlyViewed = function (options) {
    options = $.extend(
      {
        howManyToShow: 3,
        howManyToStoreInMemory: 10,
        wrapperId: 'recently-viewed-products',
        templateId: 'recently-viewed-product-template',
        onComplete: null
      },
      options || {}
    );

    var $wrapper = $('#' + options.wrapperId);
    var handles = readHandles();
    var count = Math.min(handles.length, options.howManyToShow);
    if (!count || !$wrapper.length) {
      if (options.onComplete) {
        try {
          options.onComplete();
        } catch (e) {}
      }
      return;
    }

    var slice = handles.slice(0, count);
    var base = (window.router || '') + '/products/';
    var index = 0;

    function runNext() {
      if (index >= slice.length) {
        $wrapper.show();
        if (options.onComplete) {
          try {
            options.onComplete();
          } catch (e2) {}
        }
        return;
      }
      var handle = slice[index];
      index += 1;
      $.ajax({
        url: base + encodeURIComponent(handle) + '?view=card',
        dataType: 'text',
        cache: true
      })
        .done(function (html) {
          appendCardHtml($wrapper, html);
        })
        .fail(function () {
          removeHandleFromCookie(handle);
        })
        .always(function () {
          runNext();
        });
    }

    runNext();
  };

  Shopify.Products.clearList = function () {
    $.cookie(COOKIE_NAME, null, cookieConfig);
  };

  Shopify.Products.getConfig = function () {
    return { note: 'Recently viewed now uses ?view=card; templateId is unused.' };
  };

  Shopify.Products.resizeImage = Shopify.Products.resizeImage || function (src, size) {
    if (size == null) {
      return src;
    }
    return src;
  };
})(jQuery);
